class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);

document.addEventListener('DOMContentLoaded', () => {
  const allDetails = document.querySelectorAll('.accordion details');

  allDetails.forEach((details) => {
    const summary = details.querySelector('summary');
    const content = details.querySelector('.accordion__content');

    if (details.hasAttribute('open')) {
      details.classList.add('is-open');
      content.style.height = 'auto';
    }

    summary.addEventListener('click', (e) => {
      e.preventDefault();
      if (details.classList.contains('is-animating')) return;

      const isOpen = details.classList.contains('is-open');

      allDetails.forEach((other) => {
        if (other !== details && other.classList.contains('is-open')) {
          toggleAccordion(other, false);
        }
      });

      toggleAccordion(details, !isOpen);
    });

    function toggleAccordion(el, shouldOpen) {
      const elSummary = el.querySelector('summary');
      const elContent = el.querySelector('.accordion__content');
      el.classList.add('is-animating');

      if (shouldOpen) {
        el.setAttribute('open', '');
        elContent.style.height = '0px';
        const targetHeight = elContent.scrollHeight;

        requestAnimationFrame(() => {
          elContent.style.height = targetHeight + 'px';
        });

        el.classList.add('is-open');
        elSummary.setAttribute('aria-expanded', 'true');
      } else {
        // set explicit starting height before collapsing to 0
        elContent.style.height = elContent.scrollHeight + 'px';
        requestAnimationFrame(() => {
          elContent.style.height = '0px';
        });

        el.classList.remove('is-open');
        elSummary.setAttribute('aria-expanded', 'false');
      }

      setTimeout(() => {
        el.classList.remove('is-animating');
        if (shouldOpen) {
          elContent.style.height = 'auto';
        } else {
          el.removeAttribute('open');
        }
      }, 320);
    }
  });
});
